import CheckoutFailed from './components/checkout/CheckoutFailed.vue';
import CheckoutPending from './components/checkout/CheckoutPending.vue';
import CheckoutSuccess from './components/checkout/CheckoutSuccess.vue';
import ContentstreamPost from './components/customer/ContentstreamPost.vue';
import Contentstreams from './components/customer/Contentstreams.vue';
import Videoanalysis from './components/customer/Videoanalysis.vue';
import VideoanalysisPost from './components/customer/VideoanalysisPost.vue';
import AboutUs from './views/AboutUs.vue';
import AllAuthors from './views/AllAuthors.vue';
import Auth from './views/Auth.vue';
import Author from './views/Author.vue';
import Charts from './views/Charts.vue';
import Checkout from './views/Checkout.vue';
import Contact from './views/Contact.vue';
import Dashboard from './views/customer/Dashboard.vue';
import DashboardHome from './views/customer/DashboardHome.vue';
import Profile from './views/customer/Profile.vue';
import EmailVericationVerify from './views/EmailVericationVerify.vue';
import EmailVerificationNotice from './views/EmailVerificationNotice.vue';
import Fallback from './views/Fallback.vue';
import ForgotPassword from './views/ForgotPassword.vue';
import Homepage from './views/Homepage.vue';
import Newsletter from './views/Newsletter.vue';
import ProductCategories from './views/ProductCategories.vue';
import Products from './views/Products.vue';
import ResetPassword from './views/ResetPassword.vue';
import TradingRoom from './views/TradingRoom.vue';
import TradingRoomDispatch from './views/TradingRoomDispatch.vue';
// import Heatbox from './views/Heatbox.vue'
import Blackweek from './components/blackweek/Masterclass.vue';
import Markets from './components/customer/Markets.vue';
import MarketsAnalysisPost from './components/dashboard/markets/MarketsAnalysisPost.vue';
import Marketsdouble from './components/dashboard/markets/Marketsdouble.vue';
import MarketsPackage from './components/dashboard/markets/MarketsPackage.vue';
import MarketsSingel from './components/dashboard/markets/MarketsSingel.vue';
import MarketsVideoanalysisPost from './components/dashboard/markets/MarketsVideoanalysisPost.vue';
import SpecialReportsPost from './components/dashboard/markets/SpecialReportsPost.vue';
import GiftLandingPage from './components/GiftLandingPage.vue';
import AdventCalendar from './views/AdventCalendar.vue';
import AktienanalysenLandingPage from './views/AktienanalysenLandingPage.vue';
import PriceTargets from './views/customer/PriceTargets.vue';
import DashboardTrades from './views/DashboardTrades.vue';
import EmailVerificationExpired from './views/EmailVerificationExpired.vue';
import EmailVerificationNotVerifiedUser from './views/EmailVerificationNotVerifiedUser.vue';
import EmailVerificationSuccess from './views/EmailVerificationSuccess.vue';
import GlobalMigrationLandingPage from './views/GlobalMigrationLandingPage.vue';
import BreakingNewsIndex from './views/hkcmnews/breaking-news/Index.vue';
import NewsDetail from './views/hkcmnews/Detail.vue';
import NewsIndex from './views/hkcmnews/Index.vue';
import HowTo from './views/HowTo.vue';
import HypeAktienLandingPage from './views/HypeAktienLandingPage.vue';
import HyperLandingPage from './views/HyperLandingPage.vue';
import IndizesLandingPage from './views/IndizesLandingPage.vue';
import KryptoLandingPage from './views/KryptoLandingPage.vue';
import OrchesterLandingPage from './views/OrchesterLandingPage.vue';
import OsterkampagneLandingPage from './views/OsterkampagneLandingPage.vue';
import OverviewLandingPage from './views/OverviewLandingPage.vue';
import RohstoffLandingPage from './views/RohstoffLandingPage.vue';
import Scam from './views/Scam.vue';
import SpecialReportsLandingPage from './views/SpecialReportsLandingPage.vue';
import TradingDepot from './views/TradingDepot.vue';
import TradingRoomCategory from './views/TradingRoomCategory.vue';
import VideoPost from './views/VideoPost.vue';
import Videos from './views/Videos.vue';
import ComebackRewardLandingPage from './views/ComebackRewardLandingPage.vue';
import WheelRewardLandingPage from './views/WheelRewardLandingPage.vue';

export const routes = [
    {
        name: 'homepage',
        path: '/',
        component: Homepage,
        meta: {
            auth: false,
            verified: false,
            title: 'Startseite'
        }
    },

    {
        path: '/geschenk',
        name: 'gift',
        component: GiftLandingPage,
        meta: {
            auth: false,
            verified: false,
            title: 'Geschenk'
        }
    },

    {
        path: '/lp-hype-paket',
        name: 'hype-aktien',
        component: HypeAktienLandingPage,
        meta: {
            auth: false,
            verified: false,
            title: 'Hype-Aktien-Paket',
            hideHeader: true,
            hideFooter: true
        }
    },

    {
        path: '/lp-aktienanalysen',
        name: 'aktienanalysen',
        component: AktienanalysenLandingPage,
        meta: {
            auth: false,
            verified: false,
            title: 'Aktienanalysen',
            hideHeader: true,
            hideFooter: true
        }
    },

    {
        path: '/lp-indizes',
        name: 'indizes',
        component: IndizesLandingPage,
        meta: {
            auth: false,
            verified: false,
            title: 'Indizes Landing Page',
            hideHeader: true,
            hideFooter: true
        }
    },

    {
        path: '/lp-krypto',
        name: 'krypto',
        component: KryptoLandingPage,
        meta: {
            auth: false,
            verified: false,
            title: 'Krypto Landing Page',
            hideHeader: true,
            hideFooter: true
        }
    },

    {
        path: '/lp-rohstoffe',
        name: 'rohstoffe',
        component: RohstoffLandingPage,
        meta: {
            auth: false,
            verified: false,
            title: 'Rohstoff Landing Page',
            hideHeader: true,
            hideFooter: true
        }
    },

    {
        path: '/lp-overview',
        name: 'overview',
        component: OverviewLandingPage,
        meta: {
            auth: false,
            verified: false,
            title: 'HKCM Overview',
            hideHeader: true,
            hideFooter: true
        }
    },

    {
        path: '/lp-ostern2026',
        name: 'osterkampagne',
        component: OsterkampagneLandingPage,
        meta: {
            auth: false,
            verified: false,
            title: 'Goldene Ostern – HKCM Osterkampagne',
            hideHeader: true,
            hideFooter: true
        }
    },

    {
        path: '/comebackpraemie',
        name: 'comebackpraemie',
        component: ComebackRewardLandingPage,
        meta: {
            auth: false,
            verified: false,
            title: 'ComebackPrämie',
            slimHeader: true
        }
    },

    {
        path: '/gluecksradpraemie',
        name: 'gluecksradpraemie',
        component: WheelRewardLandingPage,
        meta: {
            auth: false,
            verified: false,
            title: 'GlücksradPrämie',
            slimHeader: true
        }
    },

    {
        name: 'contact',
        path: '/kontakt',
        component: Contact,
        meta: {
            auth: false,
            verified: false,
            title: 'Kontakt'
        }
    },
    {
        path: '/lp-orchester',
        name: 'orchester',
        component: OrchesterLandingPage,
        meta: {
            auth: false,
            verified: false,
            title: 'Orchester der Kulturen – HKCM Event',
            hideHeader: true,
            hideFooter: true
        }
    },
    {
        path: '/lp-rohoel-erdgas-26',
        name: 'hyper-landing',
        component: HyperLandingPage,
        meta: {
            auth: false,
            verified: false,
            title: 'Energiemärkte verstehen – HKCM Analyse-Pakete',
            hideHeader: true,
            hideFooter: true
        }
    },
    // Video
    {
        path: '/videos',
        component: Videos,
        meta: {
            auth: false,
            verified: false,
            title: 'Videos'
        }
    },
    {
        path: '/videos/:id',
        component: VideoPost,
        meta: {
            auth: false,
            verified: false,
            title: 'Videos'
        }
    },

    {
        name: 'allauthors',
        path: '/autoren',
        component: AllAuthors,
        meta: {
            auth: false,
            verified: false,
            title: 'Alle Autoren'
        }
    },
    {
        name: 'authorbox',
        path: '/autoren/:author',
        component: Author,
        meta: {
            auth: false,
            verified: false,
            title: 'AutorenBox'
        }
    },

    // HKCM News
    {
        name: 'hkcmnews-index',
        path: '/hkcmnews',
        component: NewsIndex,
        meta: {
            auth: false,
            verified: false,
            title: 'HKCM News'
        }
    },
    {
        name: 'hkcmnews-breakingnews-index',
        path: '/hkcmnews/breaking-news',
        component: BreakingNewsIndex,
        meta: {
            auth: false,
            verified: false,
            title: 'HKCM Schlagzeilen'
        }
    },
    {
        name: 'hkcmnews-detail',
        path: '/hkcmnews/:id',
        component: NewsDetail,
        meta: {
            auth: false,
            verified: false,
            title: 'HKCM News'
        }
    },
    {
        name: 'hkcmnews-dashboard-dispatch',
        path: '/dashboard/hkcmnews/:id',
        component: NewsDetail,
        meta: {
            auth: true,
            verified: false,
            title: 'HKCM News'
        }
    },

    // HKCM News Categories
    {
        path: '/hkcmnews/aktien-news-und-analysen',
        redirect: '/hkcmnews'
    },
    {
        path: '/hkcmnews/krypto-news-und-analysen',
        redirect: '/hkcmnews'
    },
    {
        path: '/hkcmnews/rohstoffe-news-und-analysen',
        redirect: '/hkcmnews'
    },
    {
        path: '/hkcmnews/dax-news-und-analysen',
        redirect: '/hkcmnews'
    },
    {
        path: '/hkcmnews/tech-aktien-news-und-analysen',
        redirect: '/hkcmnews'
    },
    {
        path: '/hkcmnews/cannabis-aktien-news-und-analysen',
        redirect: '/hkcmnews'
    },
    {
        path: '/hkcmnews/dow-jones-news-und-analysen',
        redirect: '/hkcmnews'
    },
    {
        path: '/hkcmnews/sp500-news-und-analysen',
        redirect: '/hkcmnews'
    },
    {
        path: '/hkcmnews/nasdaq-news-und-analysen',
        redirect: '/hkcmnews'
    },
    {
        path: '/hkcmnews/silber-news-und-analysen',
        redirect: '/hkcmnews'
    },

    // Products
    {
        name: 'products',
        path: '/produkte/:id?',
        component: Products,
        meta: {
            auth: false,
            verified: false,
            title: 'Produkte'
        }
    },
    {
        name: 'productcategories',
        path: '/produktkategorien/:id?',
        component: ProductCategories,
        meta: {
            auth: false,
            verified: false,
            title: 'Produktkategorie'
        }
    },

    // Checkout
    {
        name: 'checkout',
        path: '/checkout',
        component: Checkout,
        meta: {
            auth: false,
            verified: false,
            title: 'Checkout'
        }
    },
    {
        name: 'checkout-success',
        path: '/checkout/success',
        component: CheckoutSuccess,
        meta: {
            auth: true,
            verified: false,
            title: 'Checkout'
        }
    },
    {
        name: 'checkout-failed',
        path: '/checkout/failed',
        component: CheckoutFailed,
        meta: {
            auth: true,
            verified: false,
            title: 'Checkout'
        }
    },
    {
        name: 'checkout-pending',
        path: '/checkout/pending',
        component: CheckoutPending,
        meta: {
            auth: true,
            verified: false,
            title: 'Checkout'
        }
    },
    //

    // Auth
    {
        path: '/dashboard',
        component: Dashboard,
        children: [
            {
                component: DashboardHome,
                path: '',
                name: 'dashboard'
            },
            {
                component: Contentstreams,
                path: 'contentstreams',
                name: 'contentstreams'
            },
            {
                component: PriceTargets,
                path: 'price-targets',
                name: 'pricetargets'
            },

            {
                component: TradingDepot,
                path: 'trading-depot',
                name: 'tradingDepot'
            },
            {
                component: ContentstreamPost,
                path: 'contentstreams/:id',
                name: 'contentstream'
            },
            // {
            //     component: Trades,
            //     path: 'trades',
            //     name: 'trades',
            // },
            {
                component: Videoanalysis,
                path: 'videoanalysis',
                name: 'videoanalysis'
            },
            {
                component: Markets,
                path: 'markets',
                name: 'markets'
            },
            {
                component: MarketsSingel,
                path: 'markets/:id',
                name: 'markets-singel'
            },
            {
                component: Marketsdouble,
                path: 'markets-double/:id',
                name: 'markets-double'
            },
            {
                component: MarketsPackage,
                path: 'markets-package/:id',
                name: 'markets-package'
            },

            {
                component: MarketsAnalysisPost,
                path: 'markets-analysis/:id',
                name: 'Market-analysis'
            },
            {
                component: MarketsVideoanalysisPost,
                path: 'markets-videoanalysis/:id',
                name: 'marketsvidsoanalysis'
            },
            {
                component: VideoanalysisPost,
                path: 'videoanalysis/:id',
                name: 'videoanalyse'
            },
            {
                component: SpecialReportsPost,
                path: 'special-report/:id',
                name: 'Special-report'
            },
            {
                component: NewsIndex,
                path: 'tradingroom',
                redirect: '/hkcmnews'
            },
            {
                component: NewsIndex,
                path: 'hkcmnews',
                name: 'hkcmnews'
            },
            {
                component: DashboardTrades,
                name: 'Trades',
                path: 'trades'
            },
            {
                component: AdventCalendar,
                name: 'adventskalender',
                path: 'adventskalender'
            },
            {
                component: Blackweek,
                name: 'masterclass',
                path: 'masterclass'
            }
        ],
        meta: {
            auth: true,
            verified: false,
            title: 'Dashboard',
            subPages: [
                {
                    name: 'Analysen',
                    path: '/dashboard/contentstreams/'
                },
                {
                    name: 'Video Analysen',
                    path: '/dashboard/videoanalysis/'
                },
                {
                    name: 'Trades',
                    path: '/dashboard/trades/'
                },
                {
                    name: 'Charting',
                    path: '/dashboard/charting'
                },
                {
                    name: 'Tradingroom',
                    path: '/dashboard/hkcmnews'
                },
                {
                    name: 'HKCM News',
                    path: '/dashboard/hkcmnews'
                },
                {
                    name: 'HKCM News',
                    path: '/dashboard/hkcmnews'
                },
                {
                    name: 'Unsere Charts',
                    path: '/dashboard/charts'
                },
                {
                    name: 'Performance',
                    path: '/dashboard/performance'
                }
            ]
        }
    },

    {
        name: 'Dashboard Profile',
        path: '/profile/:component?',
        component: Profile,
        meta: {
            auth: true,
            verified: false,
            title: 'Profil',
            subPages: [
                {
                    name: 'Abonnements',
                    path: '/profile/abonnements'
                },
                {
                    name: 'Rechnungen',
                    path: '/profile/invoices'
                },
                {
                    name: 'Zahlungsmethoden',
                    path: '/profile/paymentmethods'
                },
                {
                    name: 'Email Einstellungen',
                    path: '/profile/email'
                },
                {
                    name: 'Change Password',
                    path: '/profile/change-password'
                }
            ]
        }
    },
    {
        name: 'login',
        path: '/login',
        component: Auth,
        meta: {
            auth: false,
            verified: false,
            title: 'Login'
        }
    },
    {
        name: 'register',
        path: '/register',
        component: Auth,
        meta: {
            auth: false,
            verified: false,
            title: 'Registrieren'
        }
    },
    {
        name: 'forgot-password',
        path: '/forgot-password',
        component: ForgotPassword,
        meta: {
            auth: false,
            verified: false,
            title: 'Passwort zurücksetzen'
        }
    },
    {
        name: 'reset-password',
        path: '/reset-password/:token',
        component: ResetPassword,
        meta: {
            auth: false,
            verified: false,
            title: 'Passwort zurücksetzen'
        }
    },
    {
        name: 'email-verification-notice',
        path: '/email/verify',
        component: EmailVerificationNotice,
        meta: {
            auth: false,
            verified: false,
            title: 'Email Verifizieren'
        }
    },
    {
        name: 'email-verification-expired',
        path: '/email/verify/expired',
        component: EmailVerificationExpired,
        meta: {
            auth: false,
            verified: false,
            title: 'Email Verifizieren'
        }
    },
    {
        name: 'email-verification-success',
        path: '/email/verify/success',
        component: EmailVerificationSuccess,
        meta: {
            auth: false,
            verified: false,
            title: 'Success'
        }
    },
    {
        name: 'email-verification-notVerifiedUser',
        path: '/email/verify/notVerifiedUser',
        component: EmailVerificationNotVerifiedUser,
        meta: {
            auth: false,
            verified: false,
            title: 'Not Verified User'
        }
    },

    // Charts
    {
        name: 'charts',
        path: '/charts',
        component: Charts,
        meta: {
            auth: false,
            verified: false,
            title: 'Charts'
        }
    },
    {
        name: 'charts-dashboard-dispatch',
        path: '/dashboard/charts',
        component: Charts,
        meta: {
            auth: true,
            verified: false,
            title: 'Charts'
        }
    },

    // Newsletter
    {
        name: 'newsletter',
        path: '/newsletter',
        component: Newsletter,
        meta: {
            auth: false,
            verified: false,
            title: 'Newsletter'
        }
    },

    {
        name: 'antiscam',
        path: '/antiscam',
        component: Scam,
        meta: {
            auth: false,
            verified: false,
            title: 'antiscam'
        }
    },

    // About us
    {
        name: 'aboutus',
        path: '/aboutus',
        component: AboutUs,
        meta: {
            auth: false,
            verified: false,
            title: 'About us'
        }
    },

    // How To
    {
        name: 'howto',
        path: '/howto',
        component: HowTo,
        meta: {
            auth: false,
            verified: false,
            title: 'How To'
        }
    },
    {
        name: 'howto-dashboard-dispatch',
        path: '/dashboard/howto',
        component: HowTo,
        meta: {
            auth: true,
            verified: false,
            title: 'How To'
        }
    },

    // FAQs
    {
        name: 'faqs',
        path: '/howto#faqs',
        component: HowTo,
        meta: {
            auth: false,
            verified: false,
            title: 'FAQs'
        }
    },
    {
        path: '/global-migration',
        name: 'global-migration',
        component: GlobalMigrationLandingPage,
        meta: {
            auth: false,
            verified: false,
            title: 'HKCM Global Migration'
        }
    },

    {
        path: '/sonderberichte2026',
        name: 'sonderberichte',
        component: SpecialReportsLandingPage,
        meta: {
            auth: false,
            verified: false,
            title: 'HKCM Sonderberichte',
            hideHeader: true,
            hideFooter: true
        }
    },

    // Heatbox-Test (voerst deaktiviert, um keine Zielzonen an nicht-Abonnenten zu leaken.
    //               Dieser Code-Teil kann später gelöscht werden, wenn WEB-832 abgeschlossen ist.)
    // {
    //     name: 'heatbox',
    //     path: '/heatbox',
    //     component: Heatbox,
    //     meta: {
    //         auth: false,
    //         verified: false,
    //         title: "Heatbox"
    //     }
    // },

    // Fallback Route
    {
        name: 'fallback',
        path: '/:pathMatch(.*)*',
        component: Fallback
    }
];
